document.addEventListener("DOMContentLoaded", function () {
	let id = ".splide-products";
	let splideElem = document.querySelector(id);
	if (splideElem) {
		if (splideElem.splideInstance) {
			splideElem.splideInstance.destroy(true);
		}
		const splideInstance = new Splide(splideElem, {
			type: "slide",
			arrows: true,
			pagination: false,
			gap: 20,
			perPage: 3,
			padding: {
				right: 0,
				left: 0,
			},
			fixedWidth: "calc((100% - 40px) / 3)",
			breakpoints: {
				900: {
					perPage: 2,
					arrows: false,
					fixedWidth: "calc((100% - 40px) / 2)",
					padding: {
						right: 25,
						left: 0,
					},
					pagination: true,
					trimSpace: false,
				},
				500: {
					perPage: 1,
					arrows: false,
					fixedWidth: "calc(100% - 25px)",
					padding: {
						right: 25,
						left: 0,
					},
					pagination: true,
					trimSpace: false,
				},
			},
		}).mount();
		splideElem.splideInstance = splideInstance;
	}
});
